

export const frontMatter = {
	sidebar_position: 3
};
export const contentTitle = 'Applets';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-resources-applets-index-md-257.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    header: "header",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, DocCardList} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!DocCardList) _missingMdxReference("DocCardList", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "applets",
        children: "Applets"
      })
    }), "\n", _jsx(DocCardList, {}), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

